import type TableView from 'mini-mail-list-store/lib/store/schema/TableView';
import { type TableQueryType } from 'mini-mail-list-store/lib/store/schema/TableQuery';
import getCanTableLoadMore from '../../utils/tables/getCanTableLoadMore';
import loadMoreInTable from './loadMoreInTable';
import { INITIAL_LOAD_ROW_COUNT } from './TableLoadingConstants';
import { action } from 'satcheljs/lib/legacy';

/**
 * Returns flag indicating whether we should try to load more in the given table on row remove
 * @param tableView where row is removed
 */
function shouldLoadMoreOnRowRemove(tableView: TableView): boolean {
    return (
        // Don't load more on row remove for search.
        tableView.tableQuery.type === 0 &&
        tableView.itemIds.length < INITIAL_LOAD_ROW_COUNT &&
        !tableView.isLoading &&
        getCanTableLoadMore(tableView)
    );
}

/** Try loading more in table when after row removal
 * @param tableView where row is removed
 */
export default action('tryLoadMoreUponRowRemove')(function tryLoadMoreUponRowRemove(
    tableView: TableView
) {
    // Try to load more if necessary
    if (shouldLoadMoreOnRowRemove(tableView)) {
        setTimeout(function () {
            // Loading of more rows should be done asynchronously
            // We must check shouldLoadMoreOnRowRemove again after setTimeout
            if (shouldLoadMoreOnRowRemove(tableView)) {
                loadMoreInTable(tableView);
            }
        }, 10);
    }
});
